import React from 'react';

import Typography from '@mui/material/Typography';

export const Hero = () => {
  return (
    <div>
      <div
        id="hero"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          height: 700,
          backgroundImage: `url('./assets/hero.png')`,
        }}
      >
        <div>
          <Typography color="white" variant="h3">
            Increased Occupancy
            <br /> More Direct Bookings
          </Typography>
          <Typography
            color="white"
            variant="subtitle1"
            style={{ marginTop: 20 }}
          >
            On your busiest nights ensure that your hotel is 100% occupied. When
            <br />
            last minute cancellations and vacancies occur, RezyList matches new
            <br />
            loyal guests to directly book the open rooms at your hotel
          </Typography>
        </div>
      </div>
    </div>
  );
};
